import { METADATA_FIELD_LABELS } from '../../../../utils/const';

export const DEFAULT_METADATA_KEYS = {
  COMPANY_NAME: 'company_name',
  COMPANY_OVERVIEW: 'company_overview',
  STT_KEYWORDS: 'stt_keywords',
} as const;

export const RESERVED_METADATA_KEYS: ReadonlySet<string> = new Set([
  DEFAULT_METADATA_KEYS.COMPANY_NAME,
  DEFAULT_METADATA_KEYS.COMPANY_OVERVIEW,
  DEFAULT_METADATA_KEYS.STT_KEYWORDS,
]);

export const LOCKED_METADATA_KEYS: ReadonlySet<string> = new Set([
  'demo_url_expired_at',
]);

export const getMetadataFieldLabel = (key: string): string =>
  METADATA_FIELD_LABELS[key] || key;
